import Resource from "utils/resourcesUtil";

export function login(email, password, disableDeviceId = false) {
  const headers = {
    email,
    password,
  };
  if (disableDeviceId) {
    headers.deviceId = undefined;
  }

  const promise = Resource.post(
    "purchase-service/api/v1/customers/login",
    {},
    { headers }
  );
  return new Promise((resolve, reject) => {
    promise.then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

export function currentUser(token) {
  const promise = Resource.get("purchase-service/api/v1/customers/current", {
    headers: { Authorization: `Bearer ${token}` }
  });

  return new Promise((resolve, reject) => {
    promise.then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

/**
 * @param {string} customerIdentificationLast4Digits
 * @param {string} userName (phone or email)
 * @param {string} userNameType (EMAIL or PHONE)
 * @return {Promise}
 */
export function registerAccount(customerIdentificationLast4Digits, userName, userNameType) {
  const body = {
    customerIdentification: customerIdentificationLast4Digits,
    userName: userName,
    userNameType: userNameType,
  };

  return new Promise((resolve, reject) => {
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/signup/identify",
      body,
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatusAndMessage(error))
    );
  });
}

/**
 * @param {string} customerIdentificationLast4Digits
 * @param {string} userName (phone or email)
 * @param {string} userNameType (EMAIL or PHONE)
 * @return {Promise}
 */
export function forgotPassword(customerIdentificationLast4Digits, userName, userNameType) {
  const body = {
    customerIdentification: customerIdentificationLast4Digits,
    userName: userName,
    userNameType: userNameType,
  };

  return new Promise((resolve, reject) => {
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/forgot-password/identify",
      body,
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatusAndMessage(error))
    );
  });
}

export function forgotPasswordSendOtpType(otpType, token) {
  const headers = {
    Authorization: `Bearer ${token}`
  };
  return new Promise((resolve, reject) => {
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/forgot-password/otp/send",
      {
        otpType: otpType,
      },
      { headers }
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatusAndMessage(error))
    );
  });
}

export function forgotPasswordVerifyOtp(verificationCode, token) {
  const headers = {
    Authorization: `Bearer ${token}`
  };
  return new Promise((resolve, reject) => {
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/forgot-password/otp/verify",
      {
        verificationCode: verificationCode,
      },
      { headers }
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatusAndMessage(error))
    );
  });
}

export function forgetPasswordCreatePassword(password, token) {
  return new Promise((resolve, reject) => {
    const headers = {Authorization: `Bearer ${token}`};
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/forgot-password/create-password",
      {
        password: password,
      },
      { headers }
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

export function registerSendOtpType(otpType, token) {
  const headers = {
    Authorization: `Bearer ${token}`
  };
  return new Promise((resolve, reject) => {
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/signup/otp/send",
      {
        otpType: otpType,
      },
      { headers }
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatusAndMessage(error))
    );
  });
}

export function registerVerifyOtp(verificationCode, token) {
  const headers = {
    Authorization: `Bearer ${token}`
  };
  return new Promise((resolve, reject) => {
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/signup/otp/verify",
      {
        verificationCode: verificationCode,
      },
      { headers }
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatusAndMessage(error))
    );
  });
}

export function createPassword(password, token) {
  return new Promise((resolve, reject) => {
    const headers = {Authorization: `Bearer ${token}`};
    Resource.putPci(
      "/my-sunbit-service/api/v1/customer/signup/create-password",
      {
        password: password,
      },
      { headers }
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

export function updateEmailByToken(token) {
  return new Promise((resolve, reject) => {
    Resource.putPci(
      `my-sunbit-service/api/v1/customers/current/email/verify?token=${token}`,
      {},
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatusAndMessage(error))
    );
  });
}



// WEBPACK FOOTER //
// ./src/services/api/apiWithOtp/auth2.js